import { useState } from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import useAuth from '../../hooks/useAuth'

const StyledSelect = styled(Select)`
  width: 48px;
  align-self: stretch;

  .org-switcher {
    &__control {
      justify-content: center;
      background-color: var(--color-bg-input);
      border: 2px solid var(--color-text-secondary);
      border-radius: 4px;
      cursor: pointer;
      height: 100%;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;

      &:hover {
        border-color: var(--color-primary);
      }

      &--is-focused,
      &--menu-is-open {
        border-color: var(--color-primary);
        box-shadow: 0 0 0 3px rgba(151, 202, 111, 0.2);
      }
    }

    &__indicators {
      width: 100%;
    }

    &__indicator {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
      height: 100%;
      color: var(--color-input-text);
    }

    &__menu {
      color: var(--color-input-text);
      font-size: 14px;
      font-weight: bold;
      margin-top: 15px;
      right: 0;
      min-width: 200px;
      border-radius: 10px;
      background-color: white;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2),
        0 -2px 8px 0 rgba(0, 0, 0, 0.2);
    }

    &__menu-list {
      position: revert;
      border-radius: 10px;
      padding-top: 0;
      padding-bottom: 0;
      overflow-y: auto;
    }

    &__option {
      padding: 12px !important;
      cursor: pointer !important;
      color: var(--color-input-text) !important;
      background-color: white !important;
      transition: background-color 0.2s ease !important;

      &:hover,
      &--is-focused {
        background-color: #f5f5f5 !important;
      }

      &--is-selected {
        background-color: white !important;
      }

      &:first-of-type {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        &::after {
          content: '';
          width: 20px;
          height: 20px;
          clip-path: polygon(50% 50%, 0% 100%, 100% 100%);
          background-color: ${p => (p.isFirstActive || p.isFirstFocused ? 'var(--color-bg-input)' : 'white')};
          position: absolute;
          top: 0;
          right: 30px;
          transform: translateY(-100%);
        }

        &:hover::after {
          background-color: var(--color-bg-input);
        }
      }

      &:last-of-type {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }

    &__value-container {
      padding: 0;
      height: 0;
      overflow: hidden;
    }

    &__placeholder,
    &__indicator-separator {
      display: none;
    }
  }
`

const OrgSwitcher = ({ handleValueChange, setIsMenuOpen }) => {
  const { orgOptions, selectedOrg, setOrg, routeToBasePath} = useAuth()
  const [focused, setFocused] = useState('')
  const styles = {
    option: (provided, { data, isFocused }) => {
      if (isFocused) setFocused(data)
      return {
        ...provided,
        backgroundColor: isFocused ? '#f5f5f5' : 'white',
        color: '#4b5882',
        cursor: 'pointer',
        padding: '12px',
        ':active': {
          backgroundColor: '#ebebeb',
        }
      }
    }
  }

  const onOrgChange = org => {
    setOrg(org)
    routeToBasePath()
  }

  return (
    <StyledSelect
      classNamePrefix='org-switcher'
      onChange={onOrgChange}
      onInputChange={handleValueChange}
      onMenuOpen={() => setIsMenuOpen(true)}
      onMenuClose={() => setIsMenuOpen(false)}
      value={selectedOrg}
      options={orgOptions}
      isFirstActive={selectedOrg.value === orgOptions?.[0]?.value}
      isFirstFocused={focused.value === orgOptions?.[0]?.value}
      defaultValue={selectedOrg}
      noOptionsMessage={() => "No organizations found!"}
      styles={styles}
    />
  )
}

export default OrgSwitcher
